import { logger } from '../../../../utils/common/logger'

interface IWindow extends Window {
    Sailthru: {
        integration: (eventName: string, options: any) => {}
        init(options: { customerId: string }): void
    }

}

declare let window: IWindow

export default class SailthruAdapter {
    // tslint:disable-next-line:no-empty
    constructor() {
    }

    /**
     * Set cookie with userSignUp from the Sailthru JS Library
     * This automatically sets the cookie
     * We return Promise here so that we can await this function call.
     * Reference: https://getstarted.sailthru.com/developers/api-client/javascript/#userSignUp
     *
     * @param email: string - user email
     */
    public static async setCookie(email: string): Promise<void> {
        return new Promise((resolve, reject) => {
            if (window.Sailthru) {
                window.Sailthru.integration('userSignUp', {
                    email,
                    lists: {},
                    onError: (err: any) => {
                        logger('error', 'Sailthru cookie set failed', err)
                        reject()
                    },
                    onSuccess: () => {
                        logger('info', 'Sailthru cookie set successfully')
                        resolve()
                    }
                })
            } else {
                logger('error', 'Sailthru is not available. Can\'t set the cookie.')
                reject()
            }
        })
    }
}
